import { SessionActions, SessionActionTypes } from './session.actions';
import { sessionInitialState } from './_state.inits';
import { SessionState } from './_state.interfaces';
import * as uuid from 'uuid';

export function sessionReducer(state = sessionInitialState, action: SessionActions): SessionState {
  switch (action.type) {
    case SessionActionTypes.InitializeSessions: {
      if (!state.appId) {
        return { ...state, appId: uuid.v4(), loading: false };
      }
      return state;
    }
    case SessionActionTypes.LoadSessions: {
      return { ...state, loading: true, message: null };
    }
    case SessionActionTypes.LoadSessionsSuccess: {
      return {
        ...state,
        loading: false,
        auth: action.payload.session,
        userInfo: {
          menu: action.payload.menu
        }
      };
    }
    case SessionActionTypes.LoadSessionsFail: {
      return { ...state, loading: false, message: action.payload.error };
    }
    case SessionActionTypes.LoginSessions: {
      return { ...state, loading: true, message: null };
    }
    case SessionActionTypes.LoginSessionsSuccess: {
      return {
        ...state,
        loading: false,
        auth: action.payload.session,
        userInfo: {
          menu: action.payload.menu
        },
        admin: action.payload.adminFlag,
        userName: action.payload.userName,
      };
    }
    case SessionActionTypes.LoginSessionsFail: {
      return { ...state, loading: false, message: action.payload.error };
    }
    case SessionActionTypes.LogoutSessions: {
      return { ...state, loading: true, message: null };
    }
    case SessionActionTypes.LogoutSessionsSuccess: {
      return { ...state, loading: false, auth: { login: false, token: null }, userInfo: null };
    }
    case SessionActionTypes.LogoutSessionsFail: {
      return { ...state, loading: false, message: action.payload.error };
    }
    default:
      return state;
  }
}
